module.exports = __webpack_public_path__ + "static/img/文件图标@2x.ecbbdfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/文件图标@2x.png
// module id = 804
// module chunks = 382